module.exports = __webpack_public_path__ + "img/badge_english_dark.0b198655.png";